import React, { useState } from "react";
import CurriculumHeader from "components/header/CurriculumHeader";
import useCourses from "hooks/courses/useCourses";
import CoursesList from "components/courses/CoursesList";
import CourseFilters from "components/courses/CourseFilters";

const Courses = () => {
  const [filters, setFilters] = useState({});
  const { courses, isLoading, getNextPage, page, setPage, hasMoreItems } =
    useCourses(filters);
  return (
    <div className="flex flex-col justify-center gap-4 xl:gap-10 xl:mx-24 mt-10">
      <CurriculumHeader
        title="ԱԶԳԱՅԻՆ ԿՐԹԱԿԱՐԳԻ"
        sectionTitle="Դասընթացներ"
        buttonTitle="Դասեր"
        buttonLink="/lessons"
      />
      <div className="bg-white rounded-[24px]">
        <CourseFilters filters={filters} setFilters={setFilters} />
        <CoursesList
          courses={courses}
          isLoadingNextPage={isLoading}
          hasMoreItems={hasMoreItems}
          getNextPage={getNextPage}
          page={page}
          setPage={setPage}
        />
      </div>
    </div>
  );
};

export default Courses;
